var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-password-logged-user"},[_c('validate-code',{attrs:{"mode":'forgot-password',"channel":_vm.channel,"value":_vm.value},on:{"resend":_vm.onResend,"cancel":_vm.onCancel,"submit":_vm.onValidateCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }